import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface PhoneCountry {
  countryCode: string;
  dialCode: string;
}

interface PersonalInfoState {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  phoneNumber: string;
  /** Calling code from GetBasicProfile / updateBasicProfileInfo (e.g. "+91") */
  dialingCode?: string | null;
  phoneCountry: PhoneCountry | null;
  userAvatar: string;
  selectedCategories: string[];
  selectedSkills: string[];
  otherCategory?: string;
  tagline?: string;
  aboutMe?: string;
  website?: string;
  hourlyRate?: number;
  isProfileCompleted?: boolean;
  referralCode?: string;
  referralId?: string;
  /** True while profile picture is uploading after crop (settings / profile pages) */
  avatarUploadInProgress?: boolean;
}

const initialState: PersonalInfoState = {
  firstName: '',
  lastName: '',
  email: '',
  country: '',
  state: '',
  city: '',
  zipCode: '',
  phoneNumber: '',
  dialingCode: null,
  phoneCountry: null,
  userAvatar: '',
  selectedCategories: [],
  selectedSkills: [],
  otherCategory: '',
  isProfileCompleted: false,
  referralCode: '',
  referralId: null,
  avatarUploadInProgress: false,
};

const personalInfoSlice = createSlice({
  name: 'personalInfo',
  initialState,
  reducers: {
    setPersonalInfo: (state, action: PayloadAction<Partial<PersonalInfoState>>) => {
      return { ...state, ...action.payload };
    },
    setAvatarUploadInProgress: (state, action: PayloadAction<boolean>) => {
      state.avatarUploadInProgress = action.payload;
    },
    resetPersonalInfo: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setPersonalInfo, resetPersonalInfo, setAvatarUploadInProgress } = personalInfoSlice.actions;
export default personalInfoSlice.reducer; 